/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import type { ApiResult } from '../apis.d';
import { API_PREFIX } from '@shared/config';
import { httpClient } from '@shared/utils';
import type { PoolListRequest, PoolListResponse } from '@shared/types/httpTypes/applet/product/pool/list_post';
import type {
  PoolProductListRequest,
  PoolProductListResponse,
} from '@shared/types/httpTypes/applet/product/pool/product_list_get';
import type { ProductListRecommendResponse } from '@shared/types/httpTypes/applet/product/list_recommend.do_get';
import type {
  BusinessTypeResponse,
  RecommendProductListResponse,
  RecommendProductListRequest,
  BusinessTypeRequest,
  ProductListByTypeIdRequest,
  ProductListByTypeIdResponse,
} from './product.d';

// 推产品-获取业务列表
export const getProductBusinessList = async (params?: BusinessTypeRequest): Promise<ApiResult<BusinessTypeResponse>> =>
  await httpClient.get(`${API_PREFIX}api/applet/product/list_type.do`, {
    params,
  });

export const getRecommendProductList = async (
  params?: RecommendProductListRequest
): Promise<ApiResult<RecommendProductListResponse>> =>
  await httpClient.get(`${API_PREFIX}api/applet/product/list_recommend.do`, {
    params,
  });

// 推产品-根据产品类型获取产品列表
export const getProductListByTypeId = async (
  params: ProductListByTypeIdRequest
): Promise<ApiResult<ProductListByTypeIdResponse>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/product/list_by_typeId.do`, params);
};

/**
 * @description: 编辑关联产品
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const mutationRelateProductUpdate = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}relate/product/update`, params);
};

/**
 * 获取关联产品
 * @param params
 * @returns
 */
export const getRelateProductList = async (params: any): Promise<ApiResult<any>> => {
  return await httpClient.get(`${API_PREFIX}relate/product/v3/list`, { params });
};

/**
 * 获取小站精选产品下的产品池tab
 * @param params
 * @returns
 */
export const getProductPoolTabList = async (params: PoolListRequest): Promise<PoolListResponse> => {
  return await httpClient.post(`${API_PREFIX}api/applet/product/pool/list`, params);
};

/**
 * 获取产品池下产品列表（登录员工不同看到的产品列表由于可见范围不一不同）
 * @param params
 * @returns
 */
export const getProductPoolProductList = async (params: PoolProductListRequest): Promise<PoolProductListResponse> => {
  return await httpClient.get(`${API_PREFIX}api/applet/product/pool/product_list`, {
    params,
    headers: { isHideError: true },
  });
};

/**
 * 查询员工自定义产品和必选产品详情
 * @param params
 * @returns
 */
export const getDefinitionProductList = async (data: any): Promise<ProductListRecommendResponse> => {
  return await httpClient.post(`${API_PREFIX}api/applet/product/staff-definition-product`, data);
};

/**
 * 获取苏州银行理财产品
 * @param params
 * @returns
 */
export const getSzFinancingProductsList = async (params: PoolProductListRequest): Promise<PoolProductListResponse> => {
  return await httpClient.get(`${API_PREFIX}api/applet/product/sz/financing-products`, {
    params,
    headers: { isHideError: true },
  });
};
